import React, { useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import dayjs from 'dayjs';
import 'dayjs/locale/pt';
import 'dayjs/locale/es';
import 'dayjs/locale/en';

import { useUserContext } from '../user';
import { getLanguageById } from '../../utils/language';

import LanguageContext from './context';
import { sessionTraduction, reportTraduction } from '../../services/Sessions';
import i18n from '../../assets/i18n';

const LanguageContextProvider = ({ children }) => {
  const { userSession } = useUserContext();

  const [locale, setLocale] = useState('enGB');
  const [currentLanguage, setCurrentLanguage] = useState();

  useEffect(() => {
    const newCurrentLanguage = getLanguageById(userSession?.language);
    const newLocale = newCurrentLanguage?.locale;

    setLocale(newLocale);
    setCurrentLanguage(newCurrentLanguage);
  }, [userSession?.language]);

  useEffect(() => {
    if (!currentLanguage) return;

    const { name } = currentLanguage;
    const language = name.toLowerCase();
    i18n.changeLanguage(language);
    dayjs.locale(language);

    Promise.all([
      sessionTraduction(language),
      reportTraduction(language),
    ]).then(([data1, data2]) => {
      i18n.addResourceBundle(language, 'translation', data1, true, false);
      i18n.addResourceBundle(language, 'translation', data2, true, false);
    });
  }, [currentLanguage]);

  const value = useMemo(() => ({
    locale,
    currentLanguage,
  }), [locale, currentLanguage]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

LanguageContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LanguageContextProvider;
